/**
 * Inline SVG-iconen op een grid van 24 bij 24, lijndikte 1,7.
 *
 * Inline en niet uit een pakket: dat houdt de bundel klein en werkt offline,
 * wat voor een app die buiten gebruikt wordt meer waard is dan een complete
 * iconenset.
 */

type IcoonProps = { className?: string };

const basis = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export function KaartIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M9 3 3 5.5v15L9 18l6 3 6-2.5v-15L15 6 9 3Z" />
      <path d="M9 3v15M15 6v15" />
    </svg>
  );
}

export function DashboardIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <rect x="3" y="3" width="7.5" height="8.5" rx="1.5" />
      <rect x="13.5" y="3" width="7.5" height="5" rx="1.5" />
      <rect x="3" y="14.5" width="7.5" height="6.5" rx="1.5" />
      <rect x="13.5" y="11" width="7.5" height="10" rx="1.5" />
    </svg>
  );
}

export function ZoekIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 4.5 4.5" />
    </svg>
  );
}

export function LocatieIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <circle cx="12" cy="12" r="3.2" />
      <circle cx="12" cy="12" r="8" />
      <path d="M12 1.5v3M12 19.5v3M22.5 12h-3M4.5 12h-3" />
    </svg>
  );
}

export function PuntIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M12 21s7-6.1 7-11a7 7 0 1 0-14 0c0 4.9 7 11 7 11Z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  );
}

export function LagenIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="m12 3 9 4.5-9 4.5-9-4.5L12 3Z" />
      <path d="m3 12.5 9 4.5 9-4.5" />
    </svg>
  );
}

export function SluitIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="m6 6 12 12M18 6 6 18" />
    </svg>
  );
}

export function CameraIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M4 8.5h3l1.5-2.5h7L17 8.5h3a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 18v-8A1.5 1.5 0 0 1 4 8.5Z" />
      <circle cx="12" cy="13.5" r="3.5" />
    </svg>
  );
}

export function OpslaanIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M4.5 4.5h11L19.5 8.5v11a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1Z" />
      <path d="M8 4.5v5h6v-5M8 20.5v-6h8v6" />
    </svg>
  );
}

export function DownloadIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M12 3.5v11M7.5 10.5 12 15l4.5-4.5" />
      <path d="M4 17.5v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2" />
    </svg>
  );
}

export function PrullenbakIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M4 6.5h16M9.5 6.5V4h5v2.5M6.5 6.5l1 13a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1l1-13" />
    </svg>
  );
}

export function VernieuwIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M20 12a8 8 0 1 1-2.6-5.9" />
      <path d="M20 4v4.5h-4.5" />
    </svg>
  );
}

export function ChevronIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="m8 10 4 4 4-4" />
    </svg>
  );
}

export function PotloodIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M4 20h4l10-10a2.1 2.1 0 0 0-3-3L5 17v3Z" />
      <path d="m14.5 6.5 3 3" />
    </svg>
  );
}

export function VergrootIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 4.5 4.5M8.5 11h5M11 8.5v5" />
    </svg>
  );
}

/** Vinkje; gebruikt in de sectiekop en bij gekozen meerkeuze-opties. */
export function VinkIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M5 12.5 10 17.5 19 7" />
    </svg>
  );
}

/** Deurbel: bezoek aan de deur. */
export function DeurIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17" />
      <path d="M4 21h16" />
      <circle cx="14.5" cy="12" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** Telefoon: telefonisch contact. */
export function TelefoonIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M7 3h3l1.5 4-2 1.5a12 12 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A17 17 0 0 1 5 5.2 2 2 0 0 1 7 3Z" />
    </svg>
  );
}

/** Envelop: e-mail van de bewoner. */
export function EnvelopIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3.5 7 8.5 6 8.5-6" />
    </svg>
  );
}

/** Brievenbus: brief of folder bezorgd. */
export function BriefIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M4 10a4 4 0 0 1 8 0v8H4Z" />
      <path d="M12 10a4 4 0 0 1 8 0v8h-8" />
      <path d="M8 6V3h3" />
    </svg>
  );
}

/** Gebouw: informatie via de gemeente. */
export function GemeenteIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M3 21h18" />
      <path d="M5 21V10l7-5 7 5v11" />
      <path d="M10 21v-6h4v6" />
    </svg>
  );
}

/** Wolk met streep: geen verbinding. */
export function GeenVerbindingIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M17.5 17.5H7a4 4 0 0 1-.6-8A6 6 0 0 1 16 7.5" />
      <path d="M4 4l16 16" />
    </svg>
  );
}

/** Uitroepteken in een cirkel: waarschuwing. */
export function WaarschuwingIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <path d="M12 3.5 22 20H2Z" />
      <path d="M12 10v4" />
      <circle cx="12" cy="17" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** Kruisje in een cirkel: er is iets misgegaan. */
export function FoutIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="m9 9 6 6M15 9l-6 6" />
    </svg>
  );
}

/** Vinkje in een cirkel: gelukt. */
export function GeluktIcoon(props: IcoonProps): JSX.Element {
  return (
    <svg {...basis} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="m8 12 2.8 2.8L16 9.5" />
    </svg>
  );
}
